import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button, Input, Card, CardHeader, CardTitle, CardDescription, CardContent } from '@lancar-pos/ui';
import { useAuthStore } from '../../lib/auth';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { resetPassword } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await resetPassword(email);

    if (error) {
      console.error('Reset password error:', error);
    } else {
      setSent(true);
    }
    setLoading(false);
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <Card className="w-full max-w-md">
          <CardContent className="text-center py-8">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Email Terkirim</h2>
            <p className="text-gray-600 mb-4">
              Link reset password telah dikirim ke <strong>{email}</strong>
            </p>
            <p className="text-sm text-gray-500 mb-6">
              Cek inbox folder spam jika tidak menemukan email
            </p>
            <Button onClick={() => navigate({ to: '/app/login' })}>
              Kembali ke Login
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Lupa Kata Sandi</CardTitle>
          <CardDescription>
            Masukkan email yang terdaftar untuk menerima link reset password
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="email"
              label="Email"
              placeholder="email@contoh.com"
              value={email}
              onChange={setEmail}
              required
            />
            <Button type="submit" loading={loading} fullWidth>
              Kirim Link Reset
            </Button>
          </form>
          <div className="mt-4 text-center">
            <button
              onClick={() => navigate({ to: '/app/login' })}
              className="text-sm text-primary-600 hover:text-primary-700"
            >
              Kembali ke Login
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
